import { DateTime } from "luxon";
import React from "react";
import t from "../../../i18n";
import { Dashboard } from "@ui/Illustration/react";
import BlankStateV2 from "@ui/BlankStateV2";
import type { Reporting } from "../../../api/useReporting";

interface P {
  reporting: Reporting;
}

function EmptyReporting({ reporting }: P) {
  const { from, to } = React.useMemo(
    () => ({
      from: reporting.range ? DateTime.fromISO(reporting.range.min).toFormat("dd/MM/yyyy") : null,
      to: reporting.range ? DateTime.fromISO(reporting.range.max).toFormat("dd/MM/yyyy") : null,
    }),
    [reporting.range],
  );

  return (
    <BlankStateV2
      picto={<Dashboard size="l" />}
      title={t("reporting.no_results", {
        from,
        to,
      })}
    />
  );
}

export default React.memo(EmptyReporting);
